import https from '../../utils/request.js';

//1.每次切换课程/试题列表 ,查询清大知识点ID列表 ,(然后去奇峰获取资源)
export const getMenuList = (params) => {
    return https.post('/v1/learn/menu/List', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//2.前端缓存hot为true，从奇峰拉去新的知识点列表,后调用此接口更新清大
export const getMenuAdd = (params) => {
    return https.post('/v1/learn/menu/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//3.新增学习记录
export const getRecordAdd = (params) => {
    return https.post('/v1/learn/record/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//4.学习记录知识点查询
export const getLearnList = (params) => {
    return https.post('/v1/learn/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}
//4.1 学习记录知识点查询 新
export const getLearnQfList = (params) => {
    return https.post('/v1/learn/qf/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}
//5.知识点进入查询课程时调用，获取已完成课程/试题ID
export const getRecordList = (params) => {
    return https.post('/v1/learn/record/list', params,{'Content-Type ':'application/json;charset=UTF-8'})
}

//6新增弱点 - 后段对接
///

//7.弱点答题接口（每一道提提交的时候调用）
export const getWeaknessSubmit = (params) => {
    return https.post('/v1/weakness/submit', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//8.重置所有弱点练习接口（练习习题正确率<80%）
export const getWeaknessReset = (params) => {
    return https.post('/v1/learn/weakness/reset', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//9.根据知识点ID,和弱点ID 查询习题信息（包含完成状态，对错状态）
export const getWeaknessPractise = (params) => {
    return https.post('/v1/learn/learning/practise', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//10.个人弱点查询
export const getWeaknessList = (params) => {
    return https.post('/v1/learn/weakness/record/list', params,{'Content-Type':'multipart/form-data'})
}

//11.大众弱点查询
export const getWeaknessTopList = (params) => {
    return https.post('/v1/learn/weakness/top/record/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//12.添加收藏
export const getCollectAdd= (params) => {
    return https.post('/v1/learn/collect/record/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//13.取消收藏
export const getCollectRemove = (params) => {
    return https.post('/v1/learn/collect/record/remove', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//14.收藏列表查询
export const getCollectList = (params) => {
    return https.post('/v1/learn/collect/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//15.学习知识点完结操作
export const getLearnComplete = (params) => {
    return https.post('/v1/learn/complete', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//16.新增考试记录
export const getExamAdd = (params) => {
    return https.post('/v1/learn/examination/record/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//17.查询当天时长
export const getRecordDate = (params) => {
    return https.post('/v1/learn/record/date', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//18.清除学习时间记录
export const getResetDate = (params) => {
    return https.post('/v1/learn/record/rest/date', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//19.头像查询
export const getPic = (params) => {
    return https.post('/v1/user/avatar/pic', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//20.试题记录查询
export const getPracticeList = (params) => {
    return https.post('/v1/learn/practice/record/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//21.获取弱点课程
export const getWeekRecordList = (params) => {
    return https.post('/v1/learn/record/week/list', params,{'Content-Type':'application/json;charset=UTF-8'})
}

//21.获取弱点课程
export const getWxPointSet = (params) => {
    return https.post('/v1/wx/point/set', params,{'Content-Type':'application/json;charset=UTF-8'})
}
//21.万校记录时间
export const addWxClassTime = (params) => {
    return https.post('/v1/wx/class/time/add', params,{'Content-Type':'application/json;charset=UTF-8'})
}

export const getWxClassTimeSet = (params) => {
    return https.post('/v1/learn/wx/classtime/set', params,{'Content-Type':'application/json;charset=UTF-8'})
}

// 获取课程报告数据
export const getClassReport = (classId) => {
    return https.get(`/api/v1/learn/class/record/${classId}`, {}, {'Content-Type':'application/json;charset=UTF-8'})
}